import { Color } from '@diritto/common/style/color';
import { FilledNewIconProps, NewIconProps } from '@diritto/common/style/icon';

export const FavoriteEmptyIcon = ({ color = Color.Gray700, className = 'icon-[24px]', opacity }: NewIconProps) => (
  <svg
    className={className}
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
    fillOpacity={opacity}
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.5 3C14.76 3 13.09 3.81 12 5.09C10.91 3.81 9.24 3 7.5 3C4.42 3 2 5.42 2 8.5C2 12.28 5.4 15.36 10.55 20.04L12 21.35L13.45 20.03C18.6 15.36 22 12.28 22 8.5C22 5.42 19.58 3 16.5 3ZM12.1 18.55L12 18.65L11.9 18.55C7.14 14.24 4 11.39 4 8.5C4 6.5 5.5 5 7.5 5C9.04 5 10.54 5.99 11.07 7.36H12.94C13.46 5.99 14.96 5 16.5 5C18.5 5 20 6.5 20 8.5C20 11.39 16.86 14.24 12.1 18.55Z"
      fill={color}
    />
  </svg>
);

export const FavoriteFillIcon = ({ color = Color.Gray700 }: { color?: string }) => (
  <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.4827 5.48914L11.9827 5.98914L11.4827 5.48914C10.5459 4.55788 9.2786 4.03516 7.95767 4.03516C6.63674 4.03516 5.36949 4.55788 4.43268 5.48914C3.51074 6.50484 3 7.82738 3 9.1991C3 10.5708 3.51074 11.8935 4.43268 12.9092C6.50268 15.1692 12.0127 20.0292 12.0127 20.0292C12.0127 20.0292 17.5327 15.1692 19.6027 12.9092C20.5246 11.8935 21.0353 10.5708 21.0353 9.1991C21.0353 7.82738 20.5246 6.50484 19.6027 5.48914C19.1375 5.01747 18.5833 4.64296 17.9721 4.38733C17.361 4.1317 16.7051 4 16.0427 4C15.3802 4 14.7244 4.1317 14.1132 4.38733C13.5021 4.64296 12.9478 5.01747 12.4827 5.48914Z"
      fill={color}
    />
  </svg>
);

export const FavoriteIcon = ({
  fill,
  fillColor,
  color,
  opacity,
}: {
  color?: string;
  opacity?: number;
} & FilledNewIconProps) =>
  fill ? <FavoriteFillIcon color={fillColor} /> : <FavoriteEmptyIcon color={color} opacity={opacity} />;
